import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useSocket } from '../context/WebsocketContext';
import { MY_RECEIVED_VOUCHES_QUERY } from '../graphql/resolvers/vouchQueries/myReceivedVouches.gql';

export function useReceivedVouches() {
  const enabled = import.meta.env.VITE_ENABLE_VOUCHING === 'true';
  const { data, loading, refetch } = useQuery(MY_RECEIVED_VOUCHES_QUERY, {
    fetchPolicy: 'cache-and-network',
    skip: !enabled,
  });
  const { onEvent } = useSocket();

  // Live-refresh the received list when a vouch lands while /vouch is open
  // (TRIL-400). Not-on-/vouch is already covered by cache-and-network on mount.
  useEffect(() => {
    if (!enabled) return;
    return onEvent('vouch_received', () => {
      void refetch();
    });
  }, [enabled, onEvent, refetch]);

  return { received: data?.myReceivedVouches ?? [], loading };
}
